import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import FooterContainer from "./FooterContainer";

const Footer = (props) => {
  const data = useStaticQuery(graphql`
    {
      iconFacebook: file(relativePath: { eq: "images/icons/facebook.png" }) {
        childImageSharp {
          gatsbyImageData(width: 32, layout: CONSTRAINED)
        }
      }
      iconTwitter: file(relativePath: { eq: "images/icons/twitter.png" }) {
        childImageSharp {
          gatsbyImageData(width: 32, layout: CONSTRAINED)
        }
      }
      iconReddit: file(relativePath: { eq: "images/icons/reddit.png" }) {
        childImageSharp {
          gatsbyImageData(width: 32, layout: CONSTRAINED)
        }
      }
      iconInstagram: file(relativePath: { eq: "images/icons/instagram.png" }) {
        childImageSharp {
          gatsbyImageData(width: 32, layout: CONSTRAINED)
        }
      }
      iconTelegram: file(relativePath: { eq: "images/icons/telegram.png" }) {
        childImageSharp {
          gatsbyImageData(width: 32, layout: CONSTRAINED)
        }
      }
      iconMedium: file(relativePath: { eq: "images/icons/medium.png" }) {
        childImageSharp {
          gatsbyImageData(width: 32, layout: CONSTRAINED)
        }
      }
      iconYouTube: file(relativePath: { eq: "images/icons/youtube.png" }) {
        childImageSharp {
          gatsbyImageData(width: 32, layout: CONSTRAINED)
        }
      }
      iconBlockdit: file(relativePath: { eq: "images/icons/blockdit.png" }) {
        childImageSharp {
          gatsbyImageData(width: 32, layout: CONSTRAINED)
        }
      }
      iconLine: file(relativePath: { eq: "images/icons/line.png" }) {
        childImageSharp {
          gatsbyImageData(width: 32, layout: CONSTRAINED)
        }
      }
      iconTikTok: file(relativePath: { eq: "images/icons/tiktok.png" }) {
        childImageSharp {
          gatsbyImageData(width: 32, layout: CONSTRAINED)
        }
      }
      iconCoinMarketCap: file(
        relativePath: { eq: "images/icons/coinmarketcap.png" }
      ) {
        childImageSharp {
          gatsbyImageData(width: 32, layout: CONSTRAINED)
        }
      }
    }
  `);

  return <FooterContainer data={data} {...props} />;
};

export default Footer;
